import { RiCheckboxCircleFill, RiCloseCircleFill } from 'react-icons/ri'
import StatusIcon from './StatusIcon'

export const statusToIconTypes = {
  waiting: [
    'WAITING_ASSIGNMENT',
    'WAITING_FOR_CARRIER_APPROVAL',
    'WAITING_FOR_ORDER_SHARING',
    'WAITING_APPROVAL',
  ],
  everythingOK: ['ASSIGNED'],
  past: ['DELIVERED'],
  all: ['_all'],
  successfulIcon: [],
  unsuccessfulIcon: ['CANCELED'],
  noneIcon: [],
}

export const statusIconHelper = (status?: string) => {
  const icons: { [key: string]: JSX.Element } = {
    waiting: <StatusIcon type="waiting" />,
    everythingOK: <StatusIcon type="everythingOK" />,
    past: <StatusIcon type="past" />,
    none: <StatusIcon type="none" />,
    all: <StatusIcon type="all" />,
    successfulIcon: <RiCheckboxCircleFill size={16} color="#22BA46" />,
    unsuccessfulIcon: <RiCloseCircleFill size={16} color="#DD2B2A" />,
  }

  for (const [key, value] of Object.entries(statusToIconTypes)) {
    if (!!value?.find(el => el === status)) {
      return icons[key]
    }
  }
  return icons.waiting
}
